import { __rest } from "tslib";
import React from 'react';
import * as S from './card.styles';
export const Card = (_a) => {
    var { testId, className, outline, small, children, header, footer, image, icon, fullHeight = false, noContentPadding = false } = _a, rest = __rest(_a, ["testId", "className", "outline", "small", "children", "header", "footer", "image", "icon", "fullHeight", "noContentPadding"]);
    return (React.createElement(S.Card, Object.assign({}, rest, { className: className, outline: outline, small: small, "data-testid": testId, fullHeight: fullHeight }),
        image && React.createElement(S.Image, Object.assign({}, image)),
        header && (React.createElement(S.Header, { small: small },
            React.createElement(S.TitleContainer, null,
                icon && React.createElement(S.Icon, { icon: icon }),
                header))),
        React.createElement(S.Content, { small: small, noContentPadding: noContentPadding }, children),
        footer && React.createElement(S.Footer, { small: small }, footer)));
};
//# sourceMappingURL=card.js.map